import { render } from "./AdditionalSection.vue?vue&type=template&id=2e2f8de0&ts=true"
import script from "./AdditionalSection.vue?vue&type=script&lang=ts"
export * from "./AdditionalSection.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__